// import React, { useState, useEffect } from "react";
// import {
//   FaStore,
//   FaUserFriends,
//   FaBoxOpen,
//   FaShoppingCart,
// } from "react-icons/fa";

// import Banner1 from "../imagebanner.webp";
// import Banner2 from "../imagebanner.webp";
// import Banner3 from "../imagebanner.webp";
// import Banner4 from "../imagebanner.webp";

// const BannerCarousel = () => {
//   const banners = [
//     {
//       img: Banner1,
//       title: "Maamaas House Services",
//       desc: "Doorstep Services From Trusted Professionals",
//     },
//     {
//       img: Banner2,
//       title: "Order What You Love",
//       desc: "Fast Delivery · Best Discounts · 100% Secure",
//     },
//     {
//       img: Banner3,
//       title: "More Vendors · More Choices",
//       desc: "Verified Store Partners Ready To Serve",
//     },
//     {
//       img: Banner4,
//       title: "One App For Every Need",
//       desc: "Shop · Order · Book Appointments · Get Support",
//     },
//   ];

//   const playStoreURL =
//     "https://play.google.com/store/apps/details?id=com.maamaas.app";
//   const appStoreURL = "#"; 

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   /* Auto Slide */
//   useEffect(() => {
//     const interval = setInterval(
//       () => setCurrentIndex((prev) => (prev + 1) % banners.length),
//       5000
//     );
//     return () => clearInterval(interval);
//   }, [banners.length]);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   /* Static Demo Counters */
//   const counts = {
//     users: 1200,
//     vendors: 85,
//     products: 160,
//     totalOrders: 980,
//   };

//   const styles = {
//     counterRow: {
//       position: "absolute",
//       bottom: "23px",
//       left: "48%",
//       transform: "translateX(-50%)",
//       display: "grid",
//       gridTemplateColumns: "repeat(4, 1fr)",
//       gap: "15px",
//       padding: "10px 15px",
//       borderRadius: "15px",
//       zIndex: 5,
//       width: "100%",
//       maxWidth: "900px",
//       textAlign: "center",
//     },
//     counterNumber: { fontSize: "35px", fontWeight: "bold", margin: 0, color: "#fff" },
//     counterText: { fontSize: "17px", marginTop: 5, color: "#fff" },
//     icon: { fontSize: "32px", color: "#fff", marginBottom: 5 },
//   };

//   return (
//     <div style={{ width: "100%", position: "relative", fontFamily: "'Poppins', sans-serif" }}>
//       <div style={{ position: "relative", overflow: "hidden" }}>
//         {/* Overlay */}
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             background: "linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.3))",
//             zIndex: 2,
//           }}
//         ></div>

//         {/* Slider */}
//         <div
//           style={{
//             display: "flex",
//             transition: "transform 0.7s ease-in-out",
//             transform: `translateX(-${currentIndex * 100}%)`,
//           }}
//         >
//           {banners.map((b, index) => (
//             <img
//               key={index}
//               src={b.img}
//               alt={`banner-${index}`}
//               style={{
//                 flexShrink: 0,
//                 width: "100%",
//                 height: windowWidth <= 768 ? "420px" : "720px",
//                 objectFit: "cover",
//               }}
//             />
//           ))}
//         </div>

//         {/* Text Block */}
//         <div
//           style={{
//             position: "absolute",
//             top: windowWidth <= 768 ? "24%" : "35%",
//             left: windowWidth <= 768 ? "15px" : "40px",
//             zIndex: 5,
//             maxWidth: "550px",
//             color: "#fff",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: windowWidth <= 768 ? "1.9rem" : "3.3rem",
//               fontWeight: "bold",
//               textShadow: "2px 2px 6px #000",
//               marginBottom: "8px",
//             }}
//           >
//             {banners[currentIndex].title}
//           </h1>
//           <p
//             style={{
//               fontSize: windowWidth <= 768 ? "1rem" : "1.4rem",
//               textShadow: "1px 1px 4px #000",
//               marginBottom: "25px",
//             }}
//           >
//             {banners[currentIndex].desc}
//           </p>

//           {/* STORE BUTTONS */}
//           <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//             <img
//               onClick={() => (window.location.href = appStoreURL)}
//               src="https://upload.wikimedia.org/wikipedia/commons/6/67/Download_on_the_App_Store_Badge.svg"
//               alt="appstore"
//               style={{ height: "50px", cursor: "pointer" }}
//             />
//             <img
//               onClick={() => (window.location.href = playStoreURL)}
//               src="https://upload.wikimedia.org/wikipedia/commons/c/cd/Get_it_on_Google_play.svg"
//               alt="google play"
//               style={{ height: "50px", cursor: "pointer" }}
//             />
//           </div>
//         </div>

//         {/* COUNTERS BLOCK */}
//         <div style={styles.counterRow} className="counter-row">
//           <div>
//             <FaUserFriends style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.users}+</h2>
//             <p style={styles.counterText}>Users</p>
//           </div>

//           <div>
//             <FaStore style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.vendors}+</h2>
//             <p style={styles.counterText}>Partners</p>
//           </div>

//           <div>
//             <FaBoxOpen style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.products}+</h2>
//             <p style={styles.counterText}>Products</p>
//           </div>

//           <div>
//             <FaShoppingCart style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.totalOrders}+</h2>
//             <p style={styles.counterText}>Total Orders</p>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Responsive Fix */}
//       <style>
//         {`
//           @media(max-width: 768px) {
//             .counter-row {
//               grid-template-columns: repeat(4, 1fr) !important;
//               gap: 6px !important;
//               padding: 4px !important;
//             }
//             .counter-number { font-size: 18px !important; }
//             .counter-text { font-size: 10px !important; }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default BannerCarousel;




import React, { useState, useEffect } from "react";
import {
  FaStore,
  FaUserFriends,
  FaBoxOpen,
  FaShoppingCart,
} from "react-icons/fa";

import Banner1 from "../imagebanner.webp";
import Banner2 from "../imagebanner.webp";
import Banner3 from "../imagebanner.webp";
import Banner4 from "../imagebanner.webp";

const BannerCarousel = () => {
  const banners = [
    {
      img: Banner1,
      title: "Maamaas House Services",
      desc: "Doorstep Services From Trusted Professionals",
    },
    {
      img: Banner2,
      title: "Order What You Love",
      desc: "Fast Delivery · Best Discounts · 100% Secure",
    },
    {
      img: Banner3,
      title: "More Vendors · More Choices",
      desc: "Verified Store Partners Ready To Serve",
    },
    {
      img: Banner4,
      title: "One App For Every Need",
      desc: "Shop · Order · Book Appointments · Get Support",
    },
  ];

  const playStoreURL =
    "https://play.google.com/store/apps/details?id=com.maamaas.app";
  const appStoreURL = "#"; 

  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  /* Auto Slide */
  useEffect(() => {
    const interval = setInterval(
      () => setCurrentIndex((prev) => (prev + 1) % banners.length),
      5000
    );
    return () => clearInterval(interval);
  }, [banners.length]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* Static Demo Counters */
  const counts = {
    users: 1200,
    vendors: 85,
    products: 160,
    totalOrders: 980,
  };

  const styles = {
    counterRow: {
      position: "absolute",
      bottom: "23px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "15px",
      padding: "10px 15px",
      borderRadius: "15px",
      zIndex: 5,
      width: "100%",
      maxWidth: "900px",
      textAlign: "center",
    },
    counterNumber: { fontSize: "35px", fontWeight: "bold", margin: 0, color: "#fff" },
    counterText: { fontSize: "17px", marginTop: 5, color: "#fff" },
    icon: { fontSize: "32px", color: "#fff", marginBottom: 5 },
  };

  return (
    <div style={{ width: "100%", position: "relative", fontFamily: "'Poppins', sans-serif" }}>
      <div style={{ position: "relative", overflow: "hidden" }}>
        
        {/* Overlay: stronger for better text readability */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.5))",
            zIndex: 2,
          }}
        ></div>

        {/* Slider */}
        <div
          style={{
            display: "flex",
            transition: "transform 0.7s ease-in-out",
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {banners.map((b, index) => (
            <img
              key={index}
              src={b.img}
              alt={`banner-${index}`}
              style={{
                flexShrink: 0,
                width: "100%",
                height: windowWidth <= 768 ? "420px" : "720px",
                objectFit: "cover",
              }}
            />
          ))}
        </div>

        {/* Text Block */}
        <div
          style={{
            position: "absolute",
            top: windowWidth <= 768 ? "24%" : "35%",
            left: windowWidth <= 768 ? "15px" : "40px",
            zIndex: 5,
            maxWidth: "550px",
            color: "#fff",
          }}
        >
          <h1
            style={{
              fontSize: windowWidth <= 768 ? "1.9rem" : "3.3rem",
              fontWeight: "bold",
              textShadow: "2px 2px 6px #000",
              marginBottom: "8px",
            }}
          >
            {banners[currentIndex].title}
          </h1>
          <p
            style={{
              fontSize: windowWidth <= 768 ? "1rem" : "1.4rem",
              textShadow: "1px 1px 4px #000",
              marginBottom: "25px",
            }}
          >
            {banners[currentIndex].desc}
          </p>

          {/* STORE BUTTONS */}
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <img
              onClick={() => (window.location.href = appStoreURL)}
              src="https://upload.wikimedia.org/wikipedia/commons/6/67/Download_on_the_App_Store_Badge.svg"
              alt="appstore"
              style={{ height: "50px", cursor: "pointer" }}
            />
            <img
              onClick={() => (window.location.href = playStoreURL)}
              src="https://upload.wikimedia.org/wikipedia/commons/c/cd/Get_it_on_Google_play.svg"
              alt="google play"
              style={{ height: "50px", cursor: "pointer" }}
            />
          </div>
        </div>

        {/* COUNTERS BLOCK */}
        <div style={styles.counterRow} className="counter-row">
          <div>
            <FaUserFriends style={styles.icon} />
            <h2 style={styles.counterNumber}>{counts.users}+</h2>
            <p style={styles.counterText}>Users</p>
          </div>

          <div>
            <FaStore style={styles.icon} />
            <h2 style={styles.counterNumber}>{counts.vendors}+</h2>
            <p style={styles.counterText}>Partners</p>
          </div>

          <div>
            <FaBoxOpen style={styles.icon} />
            <h2 style={styles.counterNumber}>{counts.products}+</h2>
            <p style={styles.counterText}>Products</p>
          </div>

          <div>
            <FaShoppingCart style={styles.icon} />
            <h2 style={styles.counterNumber}>{counts.totalOrders}+</h2>
            <p style={styles.counterText}>Total Orders</p>
          </div>
        </div>
      </div>

      {/* Mobile Responsive Fix */}
      <style>
        {`
          @media(max-width: 768px) {
            .counter-row {
              grid-template-columns: repeat(4, 1fr) !important;
              gap: 6px !important;
              padding: 4px !important;
            }
            .counter-number { font-size: 18px !important; }
            .counter-text { font-size: 10px !important; }
          }
        `}
      </style>
    </div>
  );
};

export default BannerCarousel;
